import { NavLink, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";
import { EmptyState } from "@/components/common/States";
import { Lock } from "lucide-react";

const TABS = [
  { to: "/okonomi", label: "Oversikt", end: true },
  { to: "/okonomi/fakturaer", label: "Fakturaer" },
  { to: "/okonomi/kontrakter", label: "Kontrakter" },
  { to: "/okonomi/kostnader", label: "Kostnader" },
  { to: "/okonomi/prosjekter", label: "Prosjektøkonomi" },
  { to: "/okonomi/prognose", label: "Prognose" },
];

/**
 * Økonomi – one sidebar entry, a quiet in-module navigation. Detail pages (faktura/kontrakt/prosjekt) hide the
 * tab strip and use a back link instead, so the header stays calm.
 */
export default function FinanceLayout() {
  const { can } = useAuth();
  const { pathname } = useLocation();
  const isDetail = /^\/okonomi\/(fakturaer|kontrakter|prosjekter)\/[^/]+/.test(pathname);
  if (!can("finance:read")) {
    return (
      <div className="page-pad">
        <EmptyState icon={Lock} title="Ingen tilgang til økonomi" description="Rollen din har ikke lesetilgang til økonomimodulen. Kontakt administrator." testId="finance-no-access" />
      </div>
    );
  }
  return (
    <div className="page-pad pb-12 fade-up" data-testid="finance-layout">
      {!isDetail && (
        <nav className="-mx-1 mb-6 flex items-center gap-1 overflow-x-auto scrollbar-thin" aria-label="Økonomi" data-testid="finance-subnav">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`finance-tab-${t.to.split("/").pop() || "oversikt"}`}
              className={({ isActive }) =>
                cn(
                  "relative h-9 shrink-0 rounded-lg px-3 text-[13px] leading-9 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                  isActive ? "font-medium text-foreground after:absolute after:inset-x-3 after:-bottom-[1px] after:h-[2px] after:rounded-full after:bg-primary" : "text-muted-foreground hover:bg-muted/70 hover:text-foreground"
                )
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      )}
      <Outlet />
    </div>
  );
}
